export const mapB2CTenantToLanding = (tenantData) => {
  const theme  = tenantData?.theme  || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero   = tenantData?.hero   || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:    tenantData?.branchId,
    userId:      tenantData?.userId,
    logoUrl:     tenantData?.branding?.logoUrl     || '/assets/images/logo.png',
    companyName: tenantData?.branding?.companyName || 'Travel Agency',
    brandName:   tenantData?.branding?.brandName   || 'Travel Agency',
    email:    tenantData?.branding?.email    || 'info@travelagency.com',
    phones:   tenantData?.branding?.phones   || '9000000000',
    whatsapp: tenantData?.branding?.whatsapp || '9000000000',
    socials:  tenantData?.branding?.socials  || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,
    topBarBg:   topBar.bgColor   || '#0d9488',
    topBarText: topBar.textColor || '#ffffff',
    headerBg:   header.bgColor   || '#ffffff',
    headerText: header.textColor || '#0f172a',
    footerBg:   footer.bgColor   || '#0f2922',
    footerText: footer.textColor || '#ffffff',
    headingFont: tenantData?.branding?.headingFont || 'Plus Jakarta Sans',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',
    heroData: {
      flights:     { title: hero.flights?.title     || 'Search Flights',   subTitle: hero.flights?.subTitle     || 'Best fares guaranteed.' },
      hotels:      { title: hero.hotels?.title      || 'Search Hotels',    subTitle: hero.hotels?.subTitle      || 'Handpicked stays for you.' },
      holidays:    { title: hero.holidays?.title    || 'Explore Holidays', subTitle: hero.holidays?.subTitle    || 'Curated packages.' },
      sightseeing: { title: hero.sightseeing?.title || 'Find Activities',  subTitle: hero.sightseeing?.subTitle || 'Discover experiences.' },
    },
  };
};

export const getB2CColors_T39 = (landingData) => {
  const c1 = landingData.themeColor1 || '#0d9488'; // teal
  return {
    theme1:     c1,
    theme2:     landingData.footerBg    || '#0f2922',   // deep dark teal footer
    theme3:     landingData.headerBg    || '#ffffff',
    theme4:     landingData.themeColor4 || '#f0fdfa',   // light teal bg
    theme5:     landingData.themeColor5 || '#0f172a',
    accent:     landingData.themeColor2 || '#f43f5e',   // rose/coral
    headerText: landingData.headerText  || '#0f172a',
    footerText: landingData.footerText  || '#ffffff',
    topBarBg:   landingData.topBarBg    || '#0d9488',
    topBarText: landingData.topBarText  || '#ffffff',
  };
};

// Per-module vibrant color palette — used by ModuleTabsBar & search pages
export const MODULE_COLORS = {
  flights:     { color: '#0d9488', light: '#f0fdfa', shadow: 'rgba(13,148,136,0.25)' },
  hotels:      { color: '#0284c7', light: '#f0f9ff', shadow: 'rgba(2,132,199,0.25)'   },
  buses:       { color: '#d97706', light: '#fffbeb', shadow: 'rgba(217,119,6,0.25)'   },
  holidays:    { color: '#7c3aed', light: '#faf5ff', shadow: 'rgba(124,58,237,0.25)'  },
  sightseeing: { color: '#059669', light: '#f0fdf4', shadow: 'rgba(5,150,105,0.25)'   },
  visa:        { color: '#e11d48', light: '#fff1f2', shadow: 'rgba(225,29,72,0.25)'   },
  umrah:       { color: '#047857', light: '#ecfdf5', shadow: 'rgba(4,120,87,0.25)'    },
  hajj:        { color: '#b45309', light: '#fef3c7', shadow: 'rgba(180,83,9,0.25)'    },
};
